import { screenNames } from "clientState/AuthFlow/providers/ScreenProvider";

const { PASSWORDLESS, SIGNIN, SIGNUP } = screenNames;

export const CLICKED_ID = `${PASSWORDLESS}_click:email`;
export const SIGNUP_LINK_CLICK_LOGIN_ID = `${SIGNIN}_click:${SIGNUP}`;
